import { FC } from "react";
import { Flex } from "@otrium/core";
import { Text } from "@otrium/atoms";

interface Props {
  warning: string | JSX.Element;
}

const CartWarning: FC<Props> = ({ warning }) => {
  return (
    <Flex
      data-testid="cart-warning"
      py={2}
      px={3}
      sx={{
        overflowWrap: "break-word",
      }}
      backgroundColor="marketing.candyPink"
    >
      <Text
        role="alert"
        color="semantic.red"
        fontSize={0}
        lineHeight="1.43"
        letterSpacing="0.004em"
        sx={{
          "> a": {
            color: "semantic.red",
          },
        }}
      >
        {warning}
      </Text>
    </Flex>
  );
};

export default CartWarning;
